var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSuccess),expression:"showSuccess"}],staticClass:"pay-result-container c:col-center"},[_c('img',{staticClass:"cussess-icon",attrs:{"src":require("@/assets/icons/pay-success.svg"),"alt":""}}),_c('div',{staticClass:"success-text"},[_vm._v("支付成功，请返回微信")])])
}
var staticRenderFns = []

export { render, staticRenderFns }